'use client';

import type { ReactNode } from 'react';
import { PRODUCT } from '@/utils/constants';
import { PlaytechGate } from './playtech-gate';

export type PokerBuildPlaytechGateProps = {
    children: ReactNode;
};

export const PokerBuildPlaytechGate = ({ children }: PokerBuildPlaytechGateProps) =>
    process.env.PRODUCT === PRODUCT.POKER ? (
        <div data-testid="poker-build-playtech-gate">
            <PlaytechGate>{children}</PlaytechGate>
        </div>
    ) : (
        <>{children}</>
    );
